class TestimonialsCarousel extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.testimonials__list');
    this.items = Array.from(this.querySelectorAll('.testimonials__item'));
    this.dots = Array.from(this.querySelectorAll('.testimonials__dot'));
    this.prevButton = this.querySelector('.testimonials__arrow--prev');
    this.nextButton = this.querySelector('.testimonials__arrow--next');
    this.currentIndex = 0;

    if (!this.list || this.items.length === 0) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToIndex(index));
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scrollToIndex(this.currentIndex - 1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scrollToIndex(this.currentIndex + 1));
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            const index = this.items.indexOf(entry.target);
            if (index > -1) this.setActiveIndex(index);
          }
        });
      },
      { root: this.list, threshold: 0.6 }
    );
    this.items.forEach((item) => this.observer.observe(item));

    this.setActiveIndex(0);
  }

  scrollToIndex(index) {
    const clamped = Math.max(0, Math.min(index, this.items.length - 1));
    const target = this.items[clamped];
    if (!target) return;
    const listRect = this.list.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const left = targetRect.left - listRect.left + this.list.scrollLeft;
    this.list.scrollTo({ left, behavior: 'smooth' });
  }

  setActiveIndex(index) {
    this.currentIndex = index;
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('testimonials__dot--active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }
}

customElements.define('testimonials-carousel', TestimonialsCarousel);
